import { render, staticRenderFns } from "./PointTierForm.vue?vue&type=template&id=2bd00aa4&scoped=true"
import script from "./PointTierForm.vue?vue&type=script&lang=js"
export * from "./PointTierForm.vue?vue&type=script&lang=js"
import style0 from "./PointTierForm.vue?vue&type=style&index=0&id=2bd00aa4&prod&lang=scss&scoped=true"
import style1 from "./PointTierForm.vue?vue&type=style&index=1&id=2bd00aa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd00aa4",
  null
  
)

export default component.exports